document.addEventListener('DOMContentLoaded', () => {
  const selectElement = (selector, logMessage) => {
    const element = document.querySelector(selector)
    if (!element) {
      console.warn(logMessage)
      return
    }
    return element
  }

  const stickyAddToCartAliasElement = selectElement('[data-sticky-atc-button-alias]', 'Warning: stickyAddToCartAliasElement not found')
  const stickyAddToCart = selectElement('[data-sticky-atc-button]', 'Warning: stickyAddToCart not found')
  const footerElement = selectElement('.new-footer', 'Warning: footerElement not found')

  const toggleClasses = (isIntersecting) => {
    const action = isIntersecting ? 'remove' : 'add'
    stickyAddToCart?.classList[action]('active')
  }

  const observerCallback = (entries) => {
    entries.forEach(entry => toggleClasses(entry.isIntersecting))
  }

  const observer = new IntersectionObserver(observerCallback, { root: null, threshold: 0.1 })
  if (stickyAddToCartAliasElement) {
    observer.observe(stickyAddToCartAliasElement)
  } else {
    console.warn('stickyAddToCartAliasElement not found, observer not initiated.')
  }

  const footerObserverCallback = (entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        observer.disconnect()
        toggleClasses(true)
      } else {
        observer.observe(stickyAddToCartAliasElement)
      }
    })
  }

  const footerObserver = new IntersectionObserver(footerObserverCallback, { root: null, threshold: 0.1 })
  if (footerElement) {
    footerObserver.observe(footerElement)
  } else {
    console.warn('footerElement not found, footerObserver not initiated.')
  }

  if (stickyAddToCart) {
    const productInfo = selectElement('product-info', 'Warning: productInfo not found')
    const productInfoInputs = productInfo?.querySelectorAll('product-info [data-product-variant-radio]')
    const stickyAddToCartVariant = selectElement('[data-sticky-atc-button-variant]', 'Warning: stickyAddToCartVariant not found')

    const updateInputField = () => {
      setTimeout(() => {
        const getSelectedVariantField = selectElement('product-info form .product-variant-id', 'Warning: getSelectedVariantField not found')
        const getStickyCartFormVariantID = selectElement('[data-sticky-atc-button] .product-variant-id', 'Warning: getStickyCartFormVariantID not found')
        if (getSelectedVariantField && getStickyCartFormVariantID) {
          getStickyCartFormVariantID.value = getSelectedVariantField.value
        }
      }, 300)
    }

    const updateVariant = (selectedValue) => {
      if (stickyAddToCartVariant) {
        stickyAddToCartVariant.innerHTML = selectedValue
      }
    }

const updatePriceField = () => {
  const checkPriceInterval = setInterval(checkPriceIntervalTimer, 200);

  function checkPriceIntervalTimer() {
    let formPriceField = selectElement(
      "product-info .price-item.price-item--regular",
      "Warning: formPriceField not found"
    );
    if (!formPriceField) {
      formPriceField = selectElement(
        ".price-item",
        "Warning: formPriceField2 not found"
      );
    }

    const priceValue = formPriceField
      ? formPriceField.textContent.trim()
      : "Price not found";

    const stickyAddToCartPrice = selectElement(
      "[data-sticky-atc-button-price]",
      "Warning: stickyAddToCartPrice not found"
    );
    if (stickyAddToCartPrice) {
      stickyAddToCartPrice.innerHTML = priceValue;
    }

    const mainSubmitButton = selectElement(
      "product-info .product-form__submit",
      "Warning: mainSubmit button not found"
    );
    if (mainSubmitButton && !mainSubmitButton.disabled) {
      clearInterval(checkPriceInterval);
    }

    if (stickyAddToCartPrice) {
      if (stickyAddToCartPrice.classList.contains("discount-applied")) {
        stickyAddToCartPrice.classList.remove("discount-applied");
      }
    }
  }
};

    productInfoInputs?.forEach(radioButton => {
      radioButton.addEventListener('change', () => {
        updateVariant(radioButton.value)
        updateInputField()
        updatePriceField()
      })
    })
  }
})
